<template>
    <div class="d-flex all-after-header-box">

        <!-- Левое меню модуля -->
        <div 
            :class="{'drawer-left-wrap' : true, 'dlw-large' : (!drawerLeftMenuMini), 'drawer-menu-hover': drawerLeftMenuHover }"
            @mouseenter="LeftMenuMouseenter()"
            @mouseleave="LeftMenuMouseleave()"
        >
            <v-navigation-drawer
                absolute
                permanent
                class="drawer-menu"
                v-model="drawerLeftMenu"
            >

                <template v-if="true">
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        class="dm-actions-list"
                    >
                        <v-list-item-group
                            color="#009c95"
                        >
                            <v-list-item
                                link
                                class="v-item--active v-list-item--active drawer-menu-list-bigbtn"
                                @click="onCreateClicked"
                            >
                                <v-list-item-icon>
                                    <v-icon>mdi-plus-box</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Добавить") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>

                </template>

                <template v-if="canAnalitika">
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        shaped
                    >
                        <v-list-item-group>
                            <v-list-item
                                link
                                @click="onGetAnaliz"
                            >
                                <v-list-item-icon>
                                    <v-icon>far fa-file-spreadsheet</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Аналитика") }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                link
                                @click="onGetAnalizByPeriod"
                            >
                                <v-list-item-icon>
                                    <v-icon>far fa-file-spreadsheet</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Свод_по_исполнению") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>

                </template>

                <!--header-->
                <v-list v-if="!menuLoading && mode != 3" class="dm-list-header" nav dense shaped>   
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ getLeftMenuGroupName() }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list
                    v-if="!menuLoading && mode != 3 && meetingYears"
                    nav
                    dense
                    shaped
                >
                    <v-list-group
                        v-for="year in meetingYears"
                        :key="year"
                        :value="isPlannerBoardRoute && selectedYear == year"
                        @input="setActiveYear(year, $event)"
                        :accordion="true"
                    >
                        <template v-slot:prependIcon>
                            <v-icon :class="{ 'expanded-title': selectedYear === year, 'collapsed-title': !isPlannerBoardRoute || selectedYear != year }">far fa-columns</v-icon>
                        </template>
                        <template v-slot:activator>
                            <v-list-item :class="{ 'expanded-title': selectedYear === year, 'collapsed-title': !isPlannerBoardRoute || selectedYear != year }">
                                <v-list-item-title>{{ year }}</v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-slot:appendIcon>
                            <v-icon>fas fa-chevron-down</v-icon>
                        </template>

                        <template v-if="menuItems.length">
                            <v-list-item-group :value="year.toString() + '_' + identifier" mandatory>
                                <template v-for="menuItem in menuItems">
                                    <v-list-item
                                        :key="'MenuItem' + menuItem.id"
                                        :value="year.toString() + '_' + menuItem.id.toString()"
                                        @click="onNavigation(menuItem.id)"
                                    >
                                        <v-list-item-icon><v-icon>far fa-circle</v-icon></v-list-item-icon>
                                        <v-list-item-title v-tooltip.top="getLeftMenuItemName(menuItem)">{{ getLeftMenuItemName(menuItem) }}</v-list-item-title>
                                        <div v-if="!drawerLeftMenuMini && mode=='1'" class="dm-counter">{{ getBoardCounter(menuItem.id, year) }}</div>
                                    </v-list-item>
                                </template>
                            </v-list-item-group>
                        </template>
                        <template v-else>
                            <v-list-item
                                key="NoBoards"
                            >
                                <v-list-item-icon><v-icon>far fa-none</v-icon></v-list-item-icon>
                                <v-list-item-title>{{ $t("Нет_досок") }}</v-list-item-title>
                            </v-list-item>
                        </template>

                    </v-list-group>

                </v-list>

                <!--Планирование-->
               <v-list class="dm-list-header" nav dense shaped>   
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('Планирование')}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list nav dense shaped>
                    <v-list-item-group>
                        
                        <v-list-item
                            link
                            :key="123"
                            :to="{ name: 'Indicators' }"
                        >

                            <v-list-item-icon>
                                <v-icon>far fa-id-card-alt</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Индикаторы</v-list-item-title>
                            
                        </v-list-item>

                    </v-list-item-group>
                </v-list>

            </v-navigation-drawer>
        </div>

        <div class="content-box">
            <router-view :key="$route.fullPath" />
        </div>

        <CreateModal ref="CreateModalRef"/>
        <CreateBoardModal ref="CreateBoardModalRef"/>
        <ReportYearMonthDlg ref="ReportYearMonthDlgRef" />
        <ReportYearMonthPeriodDlg ref="ReportYearMonthPeriodDlgRef" />
    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import { mapGetters, mapActions } from 'vuex';

import CreateModal from '@/components/planner/dialogs/CreateDlg.vue';
import CreateBoardModal from '@/components/planner/dialogs/CreateBoardDlg.vue';
import ReportYearMonthDlg from '@/components/global/dialogs/ReportYearMonthDlg';
import ReportYearMonthPeriodDlg from '@/components/global/dialogs/ReportYearMonthPeriodDlg';

export default {
    name: "PlannerMain",
    components: {
        CreateModal,
        CreateBoardModal,
        ReportYearMonthDlg,
        ReportYearMonthPeriodDlg
    },
    computed: {
        ...mapGetters({ drawerLeftMenuMini: 'isDrawerLeftMenuMinimized' }),
        ...mapGetters('global/auth', { userEnterprise: 'getUserEnterpriseId'}),
        ...mapGetters('planner', { 
            menuLoading: 'isMenuLoading', 
            mode: 'getMode', 
            meetingMonths: 'getMeetingMonths', 
            meetingYears: 'getMeetingYears',
            selectedYear: 'getSelectedYear',
            identifiers: 'getIdentifiers', 
            enterprise: 'getFilterEnterprise', 
            boards: 'getBoards' }),
        identifier: {
            get: function() {
                return this.$store.getters['planner/getId'];
            },
            set: function(v) {
                if (this.identifier == v) {
                    this.$eventBus.$emit('update-board');
                }

                this.$store.commit('planner/SET_ID', v);
                this.$store.commit('planner/SET_MENU_ITEM_NAME', v ? this.getLeftMenuItemNameById(v) : '');
                this.updateCounter();
            }
        },
        canAnalitika() {
            let permissions = this.$store.getters['global/auth/getUserPermissions'];
            return permissions.includes('ViewAllPlannedMeetings');
        },
        isPlannerBoardRoute() {
            return ['Planner', 'PlannerBoard'].includes(this.$route.name);
        }
    },
    data() {
        return {
            drawerLeftMenu: true,
            drawerLeftMenuHover: false,
            menuItems: [],

            boardCounters:[],
        }
    },
    methods: {
        ...mapActions('global/actionsource', ['loadDataSource']),
        ...mapActions('planner', ['loadBoards']),
        LeftMenuMouseenter() {
            if (this.drawerLeftMenuMini)
                this.drawerLeftMenuHover = true;
        },
        LeftMenuMouseleave() {
            this.drawerLeftMenuHover = false;  
        },
        async onCreateClicked() {
            try
            {
                let { params } = await this.$refs.CreateModalRef.open();

                if (params.createType == "None.PlannedMeetingBoard") {
                    let interaction = await this.$refs.CreateBoardModalRef.open({ new: true });
                    
                    if (interaction.delete)
                        return;

                    let newBoardResponse = await httpAPI({
                        url: `api/actions/new?type=None.PlannedMeetingBoard`,
                        method: 'GET'
                    });

                    if (newBoardResponse) {
                        let newBoard = newBoardResponse.data.Payload.Data.Object;
                        newBoard.Name = interaction.name;

                        let saveNewBoardResponse = await httpAPI({
                            url: `api/actions/save?type=None.PlannedMeetingBoard`,
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            data: { Content : JSON.stringify({ parent: newBoard, childrens: null }) }
                        });

                        if (saveNewBoardResponse) {
                            await this.updateMenuItems();
                            this.$eventBus.$emit('update-board');
                        }
                    }

                    return;
                }

                this.$store.commit('planner/SET_CREATION_BAG', null);
                await this.loadDataSource({ createType: params.createType, navigate: true, common: params.isCommon ?? false });
            }
            catch (ex)
            {
                console.log(ex);
            }
        },
        async updateMenuItems() {
            this.$store.commit('planner/SET_MENU_LOADING', true);
            await this.loadBoards(this.enterprise);

            let tmpItems = [];

            switch (this.mode)
            {
                case "1":
                {
                    tmpItems = this.boards.map(b => ({ id: b.id, name: b.name }));
                    break;
                }
                case "2":               
                {
                    tmpItems = this.meetingMonths.map(m => ({ id: m.id, name: m.Value }));
                    break;
                }
                case "3":
                {
                    tmpItems = this.meetingMonths.map(m => ({ id: `${m.id}w`, name: m.Value }));
                    break;
                }
                default:
                    tmpItems = [];
                    break
            }

            this.menuItems = tmpItems;
            this.$store.commit('planner/SET_MENU_LOADING', false);
                        
            let saved = this.identifiers?.[this.mode];

            switch (this.mode)
            {
                case '1':
                    this.identifier = !saved 
                        ? this.menuItems.length > 0 
                            ? this.menuItems[0].id.toString() 
                            : '' 
                        : saved;
                    break;

                case '2':
                    this.identifier = !saved ? `${this.$moment().month() + 1}` : saved;
                    break;

                case '3':
                {
                    let currentWeekMonday = this.$moment().isoWeekday(1);
                    this.identifier = !saved ? `${currentWeekMonday.month() + 1}w` : saved;
                    break;
                }

                default:
                    break;
            }
        },
        async onBoardEdit() {
            if (this.userEnterprise != this.enterprise)
                return;

            try
            {
                let board = this.menuItems.find(mi => mi.id == this.identifier);
                let interaction = await this.$refs.CreateBoardModalRef.open({ new: false, nameKz: board.name['kk-KZ'], nameRu: board.name['ru-RU'] });

                if (interaction.delete) {
                    let filter = { Board: board.id };

                    let response = await httpAPI({
                        url: `api/plannedevent/list?filter=${JSON.stringify(filter)}`,
                        method: 'GET'
                    });

                    if (!response) {
                        this.$notify.warning(this.$t('Удаление_доски_невозможно_не_удалось_получить_данные_по_мероприятиям'));
                        return;
                    }

                    if (response.data.Payload.events?.length > 0) {
                        this.$notify.warning(this.$t('Удаление_доски_невозможно_при_наличии_мероприятий'));
                        return;
                    }

                    this.$notify.confirm(
                        this.$t('Доска_будет_удалена._Продолжить?'),
                        async () => {
                            let deleteResponse = await httpAPI({
                                url: `api/actions/delete?type=None.PlannedMeetingBoard&id=${board.id}`,
                                method: 'DELETE',
                                headers: { 'Content-Type': 'application/json' }
                            });

                            if (deleteResponse) {
                                this.$notify.success(deleteResponse.data.Payload.Message);
                                await this.updateMenuItems();

                                if (this.identifier == board.id)
                                    this.identifier = this.menuItems[0].id.toString();
                            }
                        }
                    );
                }
                else {
                    let editedBoard = {
                        "__type": "PlannedMeetingBoard:#Avrora.Objects.Modules.Planned",
                        is_new_record: false,
                        id: board.id,
                        Name: interaction.name
                    }

                    let saveBoardResponse = await httpAPI({
                        url: `api/actions/save?type=None.PlannedMeetingBoard`,
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        data: { Content : JSON.stringify({ parent: editedBoard, childrens: null }) }
                    });

                    if (saveBoardResponse) {
                        await this.updateMenuItems();
                        this.$store.commit('planner/SET_MENU_ITEM_NAME', this.getLeftMenuItemNameById(this.identifier));
                    }
                }
            }
            catch (ex)
            {
                console.log(ex);
            }
        },
        getLeftMenuGroupName() {
            let name;

            switch (this.mode)
            {
                case '1':
                    name = this.$t('Доски');
                    break;
                case '3':
                    name = this.$t('Периоды');
                    break;
                default:
                    name = this.$t('Периоды');
                    break;
            }

            return name;
        },
        getLeftMenuItemNameById(id) {
            let menuItem = this.menuItems.find(mi => mi.id == id);
            return this.getLeftMenuItemName(menuItem);
        },
        getLeftMenuItemName(item) {
            let name;

            switch (this.mode)
            {
                case '1':
                    name = this.$i18n.locale == 'kk' ? item.name['kk-KZ'] : item.name['ru-RU'];
                    break;

                default:
                    name = this.$t(item.name);
                    break;
            }

            return name;
        },
        onNavigation(id) {
            this.identifier = id.toString();

            if (!this.isPlannerBoardRoute){
                this.$router.push({name: 'PlannerBoard'});
            }
        },
        setActiveYear(year, isOpen){
            if (!this.isPlannerBoardRoute){
                this.$router.push({name: 'PlannerBoard'});
            }

            if (isOpen)
                this.$store.commit('planner/SET_SELECTED_YEAR', year);
        },
        async updateCounter(){
            if (!['1'/*,'2'*/].includes(this.mode))
                return;
            let filter = null;
            filter = { Enterprise: this.enterprise };
            let response = await httpAPI({
                    url: `api/plannedevent/boardcounter?filter=${JSON.stringify(filter)}`,
                    method: 'GET'
                });
                
                if (response) {
                    this.boardCounters = response.data.Payload;
                }
        },
        getBoardCounter(id, menuYear){
            return this.boardCounters?.find(c => c.id == id && c.year == menuYear)?.count;
        },
        async onGetAnaliz(){
            try {
                let param = await this.$refs.ReportYearMonthPeriodDlgRef.open({multiple: true});
                if (param && param.Year && param.FromMonth && param.ToMonth){
                    let exportURI = `api/download/reportbyparams?type=PlannedMeetings.Analitika&param=${JSON.stringify(param)}&mode=${process.env.NODE_ENV}`;
                    exportURI += `&token=${this.$store.getters['global/auth/getUserInfo']?.Token}`;
                    
                    let text = this.$i18n.t('Аналитика_по_плану_мероприятий');

                    this.$eventBus.$emit('on-get-report', {url: exportURI, text: text, type: 'Docx' });
                }
            }
            catch(ex){
                console.log(ex.message);
            }
        },
        async onGetAnalizByPeriod(){
            try {
                let param = await this.$refs.ReportYearMonthDlgRef.open();
                if (param && param.Year && param.Month){
                    let exportURI = `api/download/reportbyparams?type=PlannedMeetings.AnalitikaByPeriod&param={"Year":${param.Year},"Month":"${param.Month}"}&mode=${process.env.NODE_ENV}`;
                    exportURI += `&token=${this.$store.getters['global/auth/getUserInfo']?.Token}`;
                    
                    let text = this.$t('Свод_по_исполнению_за_YearMonth.message', {Year: param.Year, Month: this.$t(this.meetingMonths.find(m=> m.id == param.Month)?.Value ?? param.Month)});

                    this.$eventBus.$emit('on-get-report', {url: exportURI, text: text, type: 'Xls' });
                }
            }
            catch(ex){
                console.log(ex.message);
            }
        }
    },
    mounted() {
        this.$eventBus.$on('on-board-edit-click', async () => {
            await this.onBoardEdit();
        });
        this.$eventBus.$on('update-identifier', (id) => {
            this.identifier = id.toString();            
        });
        this.$eventBus.$on('update-boardcounter', async () => {
            await this.updateCounter();
        });
        this.$eventBus.$on('update-menu', async () => {
            await this.updateMenuItems();
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('on-board-edit-click');
        this.$eventBus.$off('update-identifier');
        this.$eventBus.$off('update-boardcounter');
        this.$eventBus.$off('update-menu');
    },
    watch: {
        mode: {
            handler: function() {
                this.updateMenuItems();
            },
            immediate: true
        }
    }
}
</script>
<style scoped>
    .expanded-title .v-list-item__title {
        font-weight: bold !important;
    }
    .collapsed-title .v-list-item__title {
        font-weight: normal !important;
    }
</style>